<div class="page-layout blank p-24" fusePerfectScrollbar>
    <h2>Welcome to the A.M. Renovation Consulting Xchange.</h2>
</div>
